const experts = [
  { initials: "DA", name: "Dr. Ananya Reddy", specialty: "Additive Manufacturing", institution: "IIT Tirupati", rating: 4.9, rate: 1500 },
  { initials: "PK", name: "Prof. Karthik Iyer", specialty: "Robotics & Mechatronics", institution: "IIIT Sri City", rating: 4.8, rate: 1800 },
  { initials: "MS", name: "Meera Sundaram", specialty: "PCB & Embedded Design", institution: "APIC Visakhapatnam", rating: 4.7, rate: 1200 },
  { initials: "RV", name: "Rahul Varma", specialty: "EV Powertrain", institution: "Ashok Leyland R&D", rating: 4.9, rate: 2200 },
];

export default experts;